

























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { DepartmentManager } from '@/models/admin/department';
import { UserModel } from '@/models/admin/users';
import { Base } from '@/components/common/base';
import { dealService, departmentService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class ManagerSavePage extends Base {
  public stores: any[];
  public manager: any = {
    id: '',
    storeId: 0,
    key: '',
    value: '',
    recordType: '',
    optionsId: '',
  };
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number = 0;
  public paymentTypes: any[];
  public blockId: string = '';
  public noLimit: boolean = false;
  public recapOptions: any[] = [];
  public disableSubmitButton: boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.dealaccounts.dealrecap.blocks',
        params: { id: this.blockId, storeId: this.storeId.toString() },
      });
    }
    if (methodName === 'submitManager') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.submitManager();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName === '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('departments.btnBack'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('departments.btnBack'),
        click: 'backToList',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    this.setFields();
    if (this.$route.params.id) {
      this.blockId = this.$route.params.id;
      this.getDealBlockOptions();
    }

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.addWatchers();
  }

  public addWatchers() {
    this.$watch('manager.isNoLimit', (newVal, oldVal) => {
      const approvalLimitField = this.formFields.find((f) => {
        return f.key === 'approvalLimit';
      });
      if (approvalLimitField) {
        approvalLimitField.templateOptions.required = !newVal;
        approvalLimitField.required = !newVal;
        approvalLimitField.templateOptions.disabled = newVal;
        approvalLimitField.templateOptions.validations = newVal
          ? ''
          : 'required';
      }
      if (newVal && this.manager.id) {
        this.form.$valid = true;
      }
    });
    this.$watch('manager.id', (newVal, oldVal) => {
      if (newVal && this.manager.isNoLimit) {
        this.form.$valid = true;
      }
    });
  }

  public validateManager(): Vue & { validate: () => boolean } {
    return this.$refs.managerForm as Vue & { validate: () => boolean };
  }

  public async submitManager(): Promise<void> {
    if(this.validateManager().validate()){
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);

        if (this.manager.sequenceNumber == 0) {
          this.showAlert(false, 'Sequence no can not be 0');
          return;
        }

        var result = this.recapOptions.filter(
          (x) => x.id == this.manager.optionsId
        )[0];

        this.manager.key = result.key;
        this.manager.value = result.value;
        this.manager.recordType = result.recordType;
        this.manager.id = '';

        await dealService.saveDealRecapLineItems(
          this.manager,
          this.blockId,
          this.storeId
        );
        this.showAlert(true, 'Recap Line Items Added Successfully');
        this.$router.push({
          name: 'admin.dealaccounts.dealrecap.blocks',
          params: { id: this.blockId },
        });
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }

  public setFields(): void {
    this.formFields = [
      {
        key: 'optionsId',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: 'Select Options',
          disabled: false,
          items: this.recapOptions,
          text: 'key',
          value: 'id',
          altag: 'Select Options',
          loading: false,
        },
      },
      {
        key: 'sequenceNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 7,
          label: 'Sequence Number',
          type: 'number',
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Sequence Number',v)
          ]
        },
      },
    ];
  }
  public async getDealBlockOptions(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const departmentUsers = await dealService.getDealRecapOptions(
        this.storeId
      );
      this.recapOptions = departmentUsers.results;
      this.setFields();
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }
}
